module.exports = __webpack_public_path__ + "2e57675323eb47aae063520d1bf5c03c.jpg";


//////////////////
// WEBPACK FOOTER
// ../components/images/taj-mahal.jpg
// module id = 1076
// module chunks = 0